import React from "react";
import UserPhoto from "../UserPhoto/userphoto";
import { getIconByChannel } from "../../utils/getIconByChannel";
import { More as OptionIcon, CallRemove } from "iconsax-reactjs";

import { ReactComponent as IconConsultTransfer } from "../../build/images/attendanceIcons/arrow-swap.svg";
import { ReactComponent as Anotacoes } from "../../build/images/popover-queue/edit-2.svg";
import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";

import "./queue-item-monitoring.styles.css";
import { createJSON } from "../../utils/createJSON";
import { Tooltippy } from "../../actions/Tippy";
import Typography from "../Typography";
import { useQueueItemMonitoring } from "./hooks/useQueueItemMonitoring";
import LightTooltip from "../LightTooltip";
import { Tooltip } from "@mui/material";
import CardItem from "./components/CardItem";

const QueueItemMonitoring = ({
  call,
  selectedCall,
  style,
  onEndCall,
  onTransferCall,
  onAnnotationCall,
  onSearch,
  search,
  onSelectCall,
}) => {
  const {
    lastMsg,
    msgIcon,
    classe,
    tempoExcedido,
    lastInteractionLabel,
    destinomsg,
    isOpenMoreOptions,
    handleCloseMoreOptions,
    handleOpenMoreOptions,
    lastMessageInfo,
    getIfIsFromAgent,
    Monitoring,
    verifyIfIsMonitoringMessage,
  } = useQueueItemMonitoring(call, search);

  const renderTagInfo = (call, tempoExcedido) => {
    let qtdMessage = <></>;
    let infosSpan = <></>;
    let text = call.qtdmessage;
    if (call.acw) {
      text = "After Call Work";
    } else if (tempoExcedido) {
      text = "Tempo excedido";
    }

    if (call.qtdmessage >= 1) {
      qtdMessage = <span className={`badge`}>{call.qtdmessage}</span>;
    }

    if (call.acw || tempoExcedido) {
      infosSpan = (
        <span
          className={`badge${tempoExcedido || call.acw ? " more-width" : ""}${
            call.acw ? " acw-color" : ""
          }`}
        >
          {text}
        </span>
      );
    }
    if (Boolean(call.isFromStandby)) {
      infosSpan = <></>;
    }
    return (
      <>
        {infosSpan} {qtdMessage}
      </>
    );
  };

  const getIndicatorColor = (lastMessageInfo) => {
    if (
      typeof lastMessageInfo === "object" &&
      Object.keys(lastMessageInfo).length === 0
    ) {
      return " __operator";
    }
    const { username, author, typemon } = lastMessageInfo;
    const isFromAAgent = getIfIsFromAgent(
      username,
      Monitoring.agent,
      author,
      typemon,
    );
    const monitoringMessage = verifyIfIsMonitoringMessage(
      isFromAAgent,
      call,
      lastMessageInfo,
    );
    const treatedTypemon = typemon
      ? monitoringMessage
        ? parseInt(typemon)
        : 1
      : parseInt(lastMessageInfo.mon_type_id);
    const isFromAManager = treatedTypemon > 1;

    if (!isFromAAgent && isFromAManager) {
      return " __manager";
    }
    if (!isFromAAgent) {
      return " __client";
    }

    return " __operator";
  };

  const renderProfilePicture = (idmidia, call, destinomsg, lastMessageInfo) => {
    return (
      <div className="chats-content__body__icon" onClick={() => {}}>
        <div
          className={`msg-indicator${getIndicatorColor(lastMessageInfo)}`}
        ></div>
        {Boolean(call) &&
          Boolean(call.cliente) &&
          typeof call.cliente === "string" && (
            <UserPhoto
              size="large"
              letterIcon={createJSON(call.cliente.trim())}
            />
          )}
        <div className="chats-content__body__icon__media">
          {getIconByChannel(idmidia)}
        </div>
      </div>
    );
  };

  const renderMoreOptions = () => {
    return (
      <ul
        className="menu-chats"
        style={{
          padding: "8px",
          gap: "8px",
          paddingTop: "0px",
          paddingBottom: "0px",
        }}
      >
        <li
          className="menu-chats__option"
          onClick={(event) => {
            event.stopPropagation();
            onTransferCall(event, call);
          }}
        >
          <IconConsultTransfer />
          <Typography.H5 weight={400} color={"gray-180"}>
            Transferir
          </Typography.H5>
        </li>
        {/* <li
          className="menu-chats__option annotation-queue-item"
          onClick={(event) => {
            // event.stopPropagation();
            onAnnotationCall(event, call);
          }}
        >
          <Anotacoes />
          <Typography.H5 weight={400} color={"gray-180"}>
            Anotações
          </Typography.H5>
        </li> */}
        <li
          className="menu-chats__option annotation-queue-item"
          onClick={(e) => {
            e.stopPropagation();
            onSearch(call);
          }}
        >
          <Search />
          <Typography.H5 weight={400} color={"gray-180"}>
            Pesquisa
          </Typography.H5>
        </li>
        <li
          className="menu-chats__option end-chat"
          onClick={(event) => {
            event.stopPropagation();
            onEndCall(call);
          }}
        >
          <CallRemove />
          <Typography.H5 weight={400} color={"red-2"}>
            Encerrar Atendimento
          </Typography.H5>
        </li>
      </ul>
    );
  };

  // const renderCardChat = (
  //   call,
  //   style,
  //   classe,
  //   tempoExcedido,
  //   dateExhib,
  //   lastMsg,
  //   msgIcon,
  //   destinomsg,
  //   lastMessageInfo,
  // ) => {
  //   console.log("raimundo_neto 211 monitoring");
  //   return (
  //     <div
  //       className={`card-chats ${
  //         call.idatendimento === selectedCall.idatendimento ? "active" : ""
  //       } `}
  //       style={style}
  //       onClick={() => {
  //         onSelectCall(call, search);
  //       }}
  //     >
  //       <div className="card-chats__main">
  //         {renderProfilePicture(
  //           call.idmidia,
  //           call,
  //           destinomsg,
  //           lastMessageInfo,
  //         )}
  //         <div className="card-chats__infos">
  //           <div className="card-chats__infos-infoMsg" onClick={() => {}}>
  //             <div className="name-time">
  //               <Tooltip
  //                 title={
  //                   call.cliente ? (
  //                     <span className="tippy-msg">
  //                       {createJSON(call.cliente)}
  //                     </span>
  //                   ) : (
  //                     ""
  //                   )
  //                 }
  //                 placement="top"
  //               >
  //                 <div className="name-info-container">
  //                   <Typography.H4 className={"name-info"} color={"gray-600"}>
  //                     {createJSON(call.cliente)}
  //                   </Typography.H4>
  //                 </div>
  //               </Tooltip>
  //               {/* <Tooltippy
  //                 content={call.cliente ? createJSON(call.cliente) : ""}
  //               >
  //                 <Typography.H4 className={"name-info"} color={"gray-600"}>
  //                   {createJSON(call.cliente)}
  //                 </Typography.H4>
  //               </Tooltippy> */}
  //               {call.idatendimento !== "voice" && (
  //                 <div className="datetime">{dateExhib}</div>
  //               )}
  //             </div>
  //             <div className="message-tag">
  //               {lastMsg && (
  //                 <Tooltip
  //                   placement="bottom"
  //                   title={<span className="tippy-msg">{lastMsg}</span>}
  //                 >
  //                   <div
  //                     key={lastMsg + msgIcon}
  //                     className={`preview-container${
  //                       tempoExcedido ? " less-width" : ""
  //                     }`}
  //                   >
  //                     {msgIcon}
  //                     <Typography.H5
  //                       className={`preview${msgIcon ? " less-width" : ""}`}
  //                       color={"gray-180"}
  //                     >
  //                       {lastMsg}
  //                     </Typography.H5>
  //                   </div>
  //                 </Tooltip>
  //                 // <Tooltippy
  //                 //   placement="top"
  //                 //   content={<span className="tippy-msg">{lastMsg}</span>}
  //                 // >
  //                 //   <div
  //                 //     key={lastMsg + msgIcon}
  //                 //     className={`preview-container${
  //                 //       tempoExcedido ? " less-width" : ""
  //                 //     }`}
  //                 //   >
  //                 //     {msgIcon}
  //                 //     <Typography.H5
  //                 //       className={`preview${msgIcon ? " less-width" : ""}`}
  //                 //       color={"gray-180"}
  //                 //     >
  //                 //       {lastMsg}
  //                 //     </Typography.H5>
  //                 //   </div>
  //                 // </Tooltippy>
  //               )}
  //               {renderTagInfo(call, tempoExcedido)}
  //             </div>
  //           </div>
  //           {call.idatendimento !== "voice" && (
  //             <LightTooltip
  //               title={renderMoreOptions()}
  //               placement="right"
  //               open={isOpenMoreOptions}
  //               onClose={() => {
  //                 handleCloseMoreOptions();
  //               }}
  //             >
  //               <div
  //                 className={`action tippy-context-menu${
  //                   isOpenMoreOptions ? " active" : ""
  //                 }`}
  //                 onClick={(e) => {
  //                   e.preventDefault();
  //                   e.stopPropagation();
  //                   handleOpenMoreOptions();
  //                 }}
  //               >
  //                 <OptionIcon variant="outline" color="#757575" />
  //               </div>
  //             </LightTooltip>
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const renderCardChat = (
    call,
    style,
    classe,
    tempoExcedido,
    dateExhib,
    lastMsg,
    msgIcon,
    destinomsg,
    lastMessageInfo,
  ) => {
    return (
      <CardItem
        key={call ? call.idatendimento : ""}
        call={call}
        selectedCall={selectedCall}
        style={style}
        onSelectCall={onSelectCall}
        search={search}
        renderProfilePicture={renderProfilePicture}
        destinomsg={destinomsg}
        lastMessageInfo={lastMessageInfo}
        createJSON={createJSON}
        dateExhib={dateExhib}
        lastMsg={lastMsg}
        msgIcon={msgIcon}
        tempoExcedido={tempoExcedido}
        renderTagInfo={renderTagInfo}
        renderMoreOptions={renderMoreOptions}
        isOpenMoreOptions={isOpenMoreOptions}
        handleCloseMoreOptions={handleCloseMoreOptions}
        handleOpenMoreOptions={handleOpenMoreOptions}
      />
    );
  };

  return (
    <div className="queue-item-monitoring">
      {renderCardChat(
        call,
        style,
        classe,
        tempoExcedido,
        lastInteractionLabel,
        lastMsg,
        msgIcon,
        destinomsg,
        lastMessageInfo,
      )}
    </div>
  );
};

export default React.memo(QueueItemMonitoring);
